import lrCodeEditorInput from './_src/lrCodeEditorInput.vue'

lrCodeEditorInput.install = function(Vue) {
  Vue.component(lrCodeEditorInput.name, lrCodeEditorInput)
}

export default lrCodeEditorInput